import { SwipeluxWidget } from "./sdk";
import { SwipeluxWidgetElement } from "./web-component";

customElements.define("swipelux-widget", SwipeluxWidgetElement);

export { SwipeluxWidget, SwipeluxWidgetElement };
